const regExpObj = {
  phone: /^1\d{10}$/,
  idCard: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  userAccount: /^(?=.*[0-9])(?=.*[a-zA-Z])(.{4,14})$/, // 注册账号:必须为数字和字母组合4~14位
  passWord: /^[0-9a-zA-Z]{6,16}$/, // 密码：6-16位字符,可包含数字，字母
  userAccountAndPhone: /^(?=.*[0-9])(?=.*[a-zA-Z])(.{4,14})|(1\d{10})$/, // 手机号或者账号登录
  email: /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/,
  num: /^[0-9]+((\.+[0-9]{1,})|([0-9]*))$/,
  positiveNumber: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
  time: /^7[0]$|^[1-6]\d$|^[1-9]$/, // 0-70
  cbtime: /^3[0]$|^[1-2]\d$|^[1-9]$/, // 0-30
  fiftyTime: /^5[0]$|^[1-4]\d$|^[1-9]$/, // 1-50
  nums: /^\+?[1-9]\d*$/,
  amount: /\d+(\.\d+)?/g // 提取数字（包括小数）
};

export default regExpObj;
